module.exports = __webpack_public_path__ + "img/copy-01.4c011780.svg";